module.exports = __webpack_public_path__ + "img/outdoor-space.c5c97a0.jpg";